export function resolveCopiedStudentGrade(students = [], session = {}) {
  const student = Array.isArray(students)
    ? students.find((item) => item && item.id === session?.studentId)
    : null;

  const liveGrade = student?.grade;
  if (liveGrade !== undefined && liveGrade !== null && String(liveGrade).trim() !== "") {
    return String(liveGrade);
  }

  const staleGrade = session?.studentGrade;
  if (staleGrade === undefined || staleGrade === null) return "";
  return String(staleGrade);
}
